import classNames from "classnames";
import React, { PropsWithChildren } from "react";
import { Dashes } from "./Dashes";
import { Trans } from "react-i18next";
interface Props {
  className?: string;
  colorClassName?: string;
}

export const DashedText: React.FC<PropsWithChildren<Props>> = ({
  className,
  colorClassName,
  children,
}) => {
  return (
    <div className="read-more inline">
      <p className={classNames(className, colorClassName)}>
        {children ?? "Read more"}
      </p>
      <Dashes className={classNames(colorClassName, "mt-5px")} />
    </div>
  );
};
